import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "../lib/analytics";

/**
 * Scrolls the window to the top whenever the route changes and emits an
 * analytics page_view. Preserves scroll position only when the user uses an
 * anchor (`#hash`) — needed for the citation `[n]` in-page jump.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => { initAnalytics(); }, []);
    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        // Defer page_view a tick so the new page's SEO has applied <title>
        setTimeout(() => trackPageView(pathname, document.title), 0);
    }, [pathname, hash]);
    return null;
}
